import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Header from './Header';
import Footer from './Footer';
import { SiteConfigProvider } from '../../lib/siteConfig';
import api from '../../lib/api';

export default function PublicLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    api.post('/analytics/visit', { path: pathname }).catch(() => {});
  }, [pathname]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SiteConfigProvider>
      <div className="min-h-screen bg-[#F8FAFC]">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </SiteConfigProvider>
  );
}
